var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeOff = function SvgGlobeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.884 2.884A10 10 0 0 1 12 2c5.523 0 10 4.477 10 10 0 1.467-.316 2.86-.884 4.116M4.93 4.93A9.97 9.97 0 0 0 2 12c0 5.523 4.477 10 10 10a9.97 9.97 0 0 0 7.071-2.929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 4.4C10.1 2.904 11.007 2 12 2c2.071 0 3.775 3.936 3.98 8.98M8.284 8.284A23.6 23.6 0 0 0 8 12c0 5.523 1.79 10 4 10 1.684 0 3.125-2.602 3.715-6.285M22 12h-3M2 12h10M2 2l20 20"
  })));
};
export default SvgGlobeOff;